/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
import { __assign } from "tslib";
import { MinimizeRmsd } from '../../../../mol-math/linear-algebra/3d/minimize-rmsd';
import { StructureElement } from '../element';
import { OrderedSet } from '../../../../mol-data/int';
import { AlignSequences } from '../../../sequence/alignment/sequence';
import { StructureProperties } from '../properties';
export function superpose(xs) {
  var ret = [];
  if (xs.length <= 0) return ret;
  var n = getMinSize(xs);
  var input = {
    a: getPositionTable(xs[0], n),
    b: getPositionTable(xs[1], n)
  };
  ret[0] = MinimizeRmsd.compute(input);

  for (var i = 2; i < xs.length; i++) {
    input.b = getPositionTable(xs[i], n);
    input.centerB = void 0;
    ret.push(MinimizeRmsd.compute(input));
  }

  return ret;
}
var reProtein = /(polypeptide|cyclic-pseudo-peptide)/i;
export function alignAndSuperpose(xs) {
  var ret = [];
  if (xs.length <= 0) return ret;
  var l = StructureElement.Loci.getFirstLocation(xs[0]);
  var subtype = StructureProperties.entity.subtype(l);
  var substMatrix = subtype.match(reProtein) ? 'blosum62' : 'default';

  for (var i = 1; i < xs.length; i++) {
    var _a = AlignSequences.compute({
      a: xs[0].elements[0],
      b: xs[i].elements[0]
    }, {
      substMatrix: substMatrix
    }),
        a = _a.a,
        b = _a.b,
        score = _a.score;

    var lociA = StructureElement.Loci(xs[0].structure, [a]);
    var lociB = StructureElement.Loci(xs[i].structure, [b]);
    var n = OrderedSet.size(a.indices);
    ret.push(__assign(__assign({}, MinimizeRmsd.compute({
      a: getPositionTable(lociA, n),
      b: getPositionTable(lociB, n)
    })), {
      alignmentScore: score
    }));
  }

  return ret;
}

function getPositionTable(xs, n) {
  var ret = MinimizeRmsd.Positions.empty(n);
  var o = 0;

  for (var _a = 0, _b = xs.elements; _a < _b.length; _a++) {
    var u = _b[_a];
    var unit = u.unit,
        indices = u.indices;
    var elements = unit.elements;
    var _c = unit.conformation,
        x = _c.x,
        y = _c.y,
        z = _c.z;

    for (var i = 0, _i = OrderedSet.size(indices); i < _i; i++) {
      var e = elements[OrderedSet.getAt(indices, i)];
      ret.x[o] = x(e);
      ret.y[o] = y(e);
      ret.z[o] = z(e);
      o++;
      if (o >= n) break;
    }

    if (o >= n) break;
  }

  return ret;
}

function getMinSize(xs) {
  if (xs.length === 0) return 0;
  var s = StructureElement.Loci.size(xs[0]);

  for (var i = 1; i < xs.length; i++) {
    var t = StructureElement.Loci.size(xs[i]);
    if (t < s) s = t;
  }

  return s;
}